import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { CHECKOUT } from '../../utils/urls';
import DoctariSpinner from '../Spinner';

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: 'calc(100vh - 5rem)',
    backgroundColor: '#f7f7f7',
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
  },
  card: {
    maxWidth: 520,
    width: '100%',
    padding: '40px 32px',
    borderRadius: 12,
    textAlign: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: theme.palette.primary.main,
    margin: '0 0 12px',
  },
  text: {
    fontSize: 15,
    color: '#6b6b6b',
    lineHeight: 1.6,
    margin: '0 0 28px',
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: 'none',
    padding: '8px 24px',
    '&:hover': {
      boxShadow: 'none',
    },
  },
}));

function SubscriptionRequired({ loading = false }) {
  const classes = useStyles();
  const history = useHistory();

  if (loading) {
    return (
      <div className={classes.page}>
        <DoctariSpinner loading />
      </div>
    );
  }

  return (
    <div className={classes.page}>
      <Paper elevation={3} className={classes.card}>
        <h1 className={classes.title}>Necesitas una suscripción</h1>
        <p className={classes.text}>
          Para hacer uso del sistema debes suscribirte a un plan. Desde tu
          perfil y la sección de suscripciones puedes revisar el estado o
          contratar un plan.
        </p>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => history.push(CHECKOUT)}
        >
          Ver planes
        </Button>
      </Paper>
    </div>
  );
}

export default SubscriptionRequired;
